// extracted by mini-css-extract-plugin
module.exports = {"text-input":"TextInput_text-input__1uGQb","text-input-label":"TextInput_text-input-label__YIAxu"};